/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_ElternkontaktInputs */

const de__field_elternkontakt = /** @type {(inputs: _Field_ElternkontaktInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elternkontakt`)
};

/**

* @param {_Field_ElternkontaktInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_elternkontakt = /** @type {((inputs?: _Field_ElternkontaktInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_ElternkontaktInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_elternkontakt(inputs)
});